module.exports = __webpack_public_path__ + "static/media/header-image.45909040.png";